import { render, staticRenderFns } from "./shopRoleList.vue?vue&type=template&id=5d001594"
import script from "./shopRoleList.vue?vue&type=script&lang=js"
export * from "./shopRoleList.vue?vue&type=script&lang=js"
import style0 from "./shopRoleList.vue?vue&type=style&index=0&id=5d001594&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports